/*jshint esversion: 6 */
import {XhrService} from "../../../default/global/ts/xhr.service";
import {addActionClass, addErrorClass, addLoadingClass, addSuccessClass} from "../../../default/global/js/utilities/updateClasses";
import {appendScriptToDOM} from "../../../default/global/js/utilities/functions";
import {FetchService} from "../../../default/global/ts/fetch.service";

function addToFavorites(itemid, variantCode, beforeSend, successSend, errorSend) {
    if (typeof beforeSend !== 'undefined') {
        beforeSend();
    }
    FetchService.get(`/em/item/${itemid}/${variantCode}/addToFavorites/`).then(res => {
        if(res.success) {
            if (typeof successSend !== 'undefined') {
                successSend(res);
            }
        } else {
            console.error(res.message);
            if (typeof errorSend !== 'undefined') {
                errorSend();
            }
        }
    }, err => {
        console.error(err);
        if (typeof errorSend !== 'undefined') {
            errorSend();
        }
    });
}

function removeFromFavorites(itemid, variantCode, beforeSend, successSend, errorSend) {
    if (typeof beforeSend !== 'undefined') {
        beforeSend();
    }

    FetchService.get(`/em/item/${itemid}/${variantCode}/removeFromFavorites/`).then(res => {
        if (res.success) {
            if (typeof successSend !== 'undefined') {
                successSend(res);
            }
        } else {
            console.error(res.message);
            if (typeof errorSend !== 'undefined') {
                errorSend();
            }
        }
    }, err => {
        console.error(err);
        if (typeof errorSend !== 'undefined') {
            errorSend();
        }
    });
}

function updateFavoritesCount(currentCount) {
    for (let count of document.querySelectorAll('.js-favoritesCount')) {
        count.innerHTML = currentCount;
        if (parseInt(count.innerHTML) === 0) {
            count.style.display = "none";
        } else {
            addActionClass(count, function () {
                count.style.display = "";
            });
        }
    }
}

function announceToScreenReader(message) {
    let liveRegion = document.getElementById('js-favorites-live');
    if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'js-favorites-live';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'screenreader-only';
        document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    requestAnimationFrame(() => { liveRegion.textContent = message; });
}

function toggleFavoriteBtnClasses(el) {
    let icon = el.querySelector('.icon');
    let filledIconClass = 'icon-favorites-filled';
    let emptyIconClass = 'icon-favorites';
    if (el.classList.contains("js-addToFavorites")) {
        el.classList.remove("js-addToFavorites");
        el.classList.add("js-removeFromFavorites");
        el.setAttribute('aria-pressed', 'true');
        el.setAttribute('aria-label', el.dataset.labelRemove || el.getAttribute('aria-label'));

        if (icon) {
            icon.classList.remove(emptyIconClass);
            icon.classList.add(filledIconClass);
        }

        announceToScreenReader(el.dataset.labelRemove || '');
    } else {
        el.classList.remove("js-removeFromFavorites");
        el.classList.add("js-addToFavorites");
        el.setAttribute('aria-pressed', 'false');
        el.setAttribute('aria-label', el.dataset.labelAdd || el.getAttribute('aria-label'));

        if (icon) {
            icon.classList.remove(filledIconClass);
            icon.classList.add(emptyIconClass);
        }

        announceToScreenReader(el.dataset.labelAdd || '');
    }
}

export function triggerFavoritesBtns() {
    document.addEventListener("click", function (e) {
        let target = e.target;

        const addBtn = target.closest(".js-addToFavorites");
        if (addBtn) {
            e.stopPropagation();
            let itemID = addBtn.dataset.id;
            let variantCode = addBtn.dataset.variant_code;
            if (itemID) {
                if (document.body.classList.contains("favorites")) {
                    addLoadingClass(addBtn);
                    window.location.href = "?action=shop_add_item_to_favorites&action_id=" + itemID + "&variant_code="+variantCode;
                }else{
                    addToFavorites(itemID, variantCode, () => {

                    }, (result) => {
                        if (result.success) {
                            toggleFavoriteBtnClasses(addBtn);
                            updateFavoritesCount(result.data.currFavoriteCount);

                            if (result.data.includeTagMgr) {
                                const formData = new FormData();
                                formData.append('action_id', itemID);
                                formData.append('variant_code', variantCode);
                                XhrService.generalAjaxCall('add_item_to_favorite', formData).then(tmResult => {
                                    if (tmResult.tagManager) {
                                        appendScriptToDOM(tmResult.tagManager, true);
                                    }
                                });
                            }
                        } else {
                            addErrorClass(addBtn);
                        }
                    }, () => {
                        addErrorClass(addBtn);
                    });
                }
            } else {
                console.error("item id not found");
            }
            e.preventDefault();
        }

        const removeBtn = target.closest(".js-removeFromFavorites");
        if (removeBtn) {
            e.stopPropagation();
            const itemID = removeBtn.dataset.id;
            let variantCode = removeBtn.dataset.variant_code;
            if (itemID) {
                if (document.body.classList.contains("favorites")) {
                    addLoadingClass(removeBtn);
                    window.location.href = "?action=shop_remove_item_from_favorites&action_id=" + itemID + "&variant_code="+variantCode;
                } else {
                    removeFromFavorites(itemID, variantCode, () => {

                    }, (result) => {
                        if (result.success) {
                            toggleFavoriteBtnClasses(removeBtn);
                            updateFavoritesCount(result.data.currFavoriteCount);
                            if (result.tagManager) { // TODO move to seperate ajax call
                                appendScriptToDOM(result.tagManager, true);
                            }
                        } else {
                            addErrorClass(removeBtn);
                        }
                    }, () => {
                        addErrorClass(removeBtn);
                    });
                }
            } else {
                console.error("item id not found");
            }
            e.preventDefault();
        }
    }, true);
}